const commonDateFormatObj = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

const FORMATS = {
  "mm/dd/yyyy": {
    region: "en-US",
    format: commonDateFormatObj,
  },
  "yyyy-mm-dd": {
    region: "en-CA",
    format: commonDateFormatObj,
  },
};

/**
 * Returns a string date with one of the available formats.
 * @param {Date object} date Date object to be formatted.
 *
 * @return {string} Formatted date.
 */
const formatDate = (date, format = "yyyy-mm-dd") => {
  const formatConfig = FORMATS[format];
  if (!formatConfig)
    throw new Error(
      "The desired format is not available, please add it to the catalog",
    );

  const formatter = Intl.DateTimeFormat(
    formatConfig.region,
    formatConfig.format,
  );

  return date ? formatter.format(date) : null;
};

export default formatDate;
